export default {
  mutationUsers(state, payload) {
    state.users = payload;
  },
  mutationUser(state, payload) {
    state.user = payload;
  },
  mutationPartners(state, payload) {
    state.partners = payload;
  },
  mutationStores(state, payload) {
    state.stores = payload;
  },
  mutationAreps(state, payload) {
    state.areps = payload;
  },
};
